import { Grid } from '@material-ui/core';
import React from 'react'

export const NoDataTabsMessage = ({ message }) => {
    return (
        <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        >
            <Grid item>
                { message }
            </Grid>
        </Grid>
    )
}


